import React from 'react'
import type { ListItemAvatarProps as MuiListItemAvatarProps } from '@material-ui/core/ListItemAvatar'
import MuiListItemAvatar from '@material-ui/core/ListItemAvatar'

export type ListItemAvatarProps = MuiListItemAvatarProps

function ListItemAvatar(props: ListItemAvatarProps) {
  return <MuiListItemAvatar {...props} />
}

export default ListItemAvatar
